module.exports = "build/assets/RingsideWide-Bold.f9814323.woff2";